(function(){
  // Auto-tag elements for scroll reveal
  var TARGETS = ['.pdp-hero > .wrap > div', '.tool-card', '.use-card', '.tier', '.proof-card', '.faq-item', '.diff-grid > div', '.promise-grid > div', '.tools-head', '.final-cta .wrap'];
  TARGETS.forEach(function(sel){
    document.querySelectorAll(sel).forEach(function(el, i){
      el.classList.add('reveal');
      if (i < 5) el.classList.add('reveal-delay-' + i);
    });
  });
  // Apply reveal
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function(el){ io.observe(el); });
  // Nav scrolled state
  var nav = document.querySelector('.nav');
  function onScroll(){ if(nav) nav.classList.toggle('scrolled', (window.scrollY||0) > 8); }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();
